export class WorkOrderPhotoModel {
    public id: number;
    public originalFileName: string;
    public fileName: string;
    public fileUrl: string;
}
